/**
 * Run a function when document is ready, while also maintaining compatibility with the way Plugin loads scripts.
 * @param {String} label The name of the script,
 * @param {Function} fn The function to run when ready
 */
module.exports = function runScriptOnReady(label, fn) {
	const THE_SCRIPT = function() {
		const $onReady = require('public/js/lib/on-ready');

		$onReady({
			rp$,
			window,
			label,
			fn,
		});
	};

	try {
		// Because __CURRENT_SCRIPT__ is injected by plugin Client, we need this here to try and pass it up to the plugin code
		if (typeof __CURRENT_SCRIPT__ === 'undefined') {
			throw new Error('__CURRENT_SCRIPT__ is not defined');
		}
		__CURRENT_SCRIPT__ = THE_SCRIPT;
	} catch (e) {
		THE_SCRIPT();
	}
};
